<template>
  <div>
    <v-container>
      <v-row>
        <v-col>
          <v-breadcrumbs :items="items" :divider="'|'" class="py-0">
            <template v-slot:item="props">
              <v-breadcrumbs-item :to="props.item.to" :class="[props.item.disabled && 'disabled']">
                <span style="color: black;">{{ props.item.text }}</span>
              </v-breadcrumbs-item>
            </template>
          </v-breadcrumbs>
        </v-col>
      </v-row>

      <v-row>
        <v-col class="text-center line-height-eventos-title">
          <h1 class="PTSerif bold eventos-title" style="white-space: pre-wrap">{{evento.titulo}}</h1>
        </v-col>
      </v-row>

      <!-- **********************inicia row en desktop************** -->
      <v-row v-for="(row,i) in evento.imagenes" :key="i">
        <v-col v-for="(column,c) in row.value" :key="c" cols="12" :md="12 / row.value.length">
          <template v-for="(children,ch) in column.children">
            <v-img
              :src="'https://flordeazaharcms.actstudio.xyz/'+children.settings.image.path"
              :key="ch"
              height="400px"
            ></v-img>
          </template>
        </v-col>
      </v-row>
      <!-- **********************termina row en desktop***************** -->
    </v-container>
  </div>
</template>

<script>
export default {
  data() {
    return {
      items: [
        {
          text: "Inicio",
          disabled: false,
          to: "/"
        },
        {
          text: "Eventos",
          disabled: true
        }
      ],
      evento: {}
    };
  },
  created: function() {
    fetch(
      "https://flordeazaharcms.actstudio.xyz/api/singletons/get/Eventos?token=bd38a532024ddfd195a5fdefd8eb98"
    )
      .then(res => res.json())
      .then(res => (this.evento = res));
  }
};
</script>